import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { MediaService } from '../../../services/MediaService';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';

interface State {
    mediaList: ReqType.Media[];
    idmedia: number;
    redirect: boolean;
}

interface Props {
}

/**
 * ce composant permet la gestion des medias
 */
export class MediaManagmentList extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
            mediaList: [],
            redirect: false,
            idmedia: 0
        };
        this.getMedia();
    }

    render() {
        // let tab: JSX.Element [] = [];

        let tab = this.state.mediaList.map((media: ReqType.Media, index: number) => {

            return (
                <tr
                    key={index}
                >
                    <td>{media.user.username}</td>
                    <td>{media.nom}</td>
                    {this.getDate(media)}
                    <td><Link to={'/gestion-media/' + media.id}>Lien</Link></td>
                    <td>{media.description}</td>
                    {this.getEtat(media)}
                    <td>{this.getbutton(index)}</td>
                    <td>
                        <LoaderButton
                            className="btn btn-danger"
                            confirmation={true}
                            modalBody={'Le média: ' + media.nom +
                                ' sera supprimé définitivement. En êtes-vous sur ?'}
                            modalTitle="Suppression du média"
                            onClick={
                                () => {
                                    return MediaService.getInstance()
                                        .supprimerMedia(this.state.mediaList[index])
                                        .then(
                                            () => {
                                                this.state.mediaList.splice(index, 1);
                                                this.setState({ mediaList: this.state.mediaList });
                                            }
                                        );
                                }
                            }
                        >
                            Supprimer
                        </LoaderButton>
                    </td>
                </tr>
            );
        }
        );
        if (this.state.redirect) {
            return <Redirect to={'/gestion-media/' + this.state.idmedia} />;
        } else {
            return (
                <div>
                    <TableChorinitia
                        header={
                            <thead className="thead-light">
                                <tr>
                                    <th scope="col">Pseudo de l'auteur</th>
                                    <th scope="col">Nom</th>
                                    <th scope="col">Date de création</th>
                                    <th scope="col">lien</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Etat</th>
                                    <th scope="col">Action</th>
                                    <th scope="col">Supprimer</th>
                                </tr>
                            </thead>
                        }
                    >
                        <tbody>
                            {tab}
                        </tbody>
                    </TableChorinitia>
                </div>
            );
        }
    }

    private getDate(media: ReqType.Media) {
        var date = new Date(Number.parseInt(media.created_at) * 1000);
        return (<td>{date.toLocaleString()}</td>);
    }

    private getEtat(media: ReqType.Media) {
        if (media.afficher === 1) {
            return (<td className="table-success">Visible</td>);
        } else {
            return (<td className="table-danger">Non Visible</td>);
        }
    }

    private getbutton(index: number) {
        if (this.state.mediaList[index].afficher === 1) {
            return (
                <LoaderButton
                    className="btn btn-warning"
                    confirmation={true}
                    modalBody="En êtes-vous sur ?"
                    modalTitle="Rendre ce média non visible"
                    onClick={
                        () => {
                            return MediaService.getInstance().changeAfficher(this.state.mediaList[index], false).then(
                                () => {
                                    this.state.mediaList[index].afficher = 0;
                                    this.setState({ mediaList: this.state.mediaList });
                                }
                            );
                        }
                    }
                >
                    Invalider
                </LoaderButton>
            );
        } else {
            return (
                <LoaderButton
                    className="btn btn-success"
                    confirmation={true}
                    modalBody="En êtes-vous sur ?"
                    modalTitle="Rendre ce média visible"
                    onClick={
                        () => {
                            return MediaService.getInstance().changeAfficher(this.state.mediaList[index], true)
                                .then(
                                    () => {
                                        this.state.mediaList[index].afficher = 1;
                                        this.setState({ mediaList: this.state.mediaList });
                                    }
                                );
                        }
                    }
                >
                    Valider
                </LoaderButton>
            );
        }
    }

    private getMedia() {
        MediaService.getInstance().getAllMediaList().then(
            (mediaList: ReqType.Media[]) => {
                this.setState({
                    mediaList: mediaList
                });
            }
        );
    }
} 


// WEBPACK FOOTER //
// ./src/components/MediasPage/internalComponents/MediaManagmentList.tsx